import { PaginationType } from '../../types/CommonTypes';
import { LanguageType } from '../../types/LanguageTypes';

export const S3_DOMAIN = process.env.REACT_APP_STORAGE_URL;
export const CDN_DOMAIN = process.env.REACT_APP_CDN_URL;

export const FILE_NAME_TYPE = {
  AVATAR: 'AVATAR',
  MODEL: 'model',
  ICON: 'icon',
  MODELS: 'MODELS',
  PANO: 'PANO',
  IMAGE: 'IMAGE',
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  LOGO: 'logo',
  ITEM_INFO: {
    ICON: 'ICON',
    LOGO: 'LOGO',
    AUDIO: 'AUDIO',
    COLLECTION_ICON: 'COLLECTION_ICON',
    CATEGORY_GALLERY: 'CATEGORY_GALLERY',
    MODEL_3D_ANDROID: 'MODEL_3D_ANDROID',
    MODEL_3D_IOS: 'MODEL_3D_IOS',
  },
  TEXTURE: 'TEXTURE',
};

export const POI_TYPE = {
  MOVING: 'MOVING',
  SOUND: 'SOUND',
  INFO: 'INFO',
  POPUP: 'POPUP',
  PHOTO: 'PHOTO',
  VIDEO: 'VIDEO',
  ITEM_INFO: 'ITEM_INFO',
  POLYGON: 'POLYGON',
  LENSFLARE: 'LENSFLARE',
  NADIR_LOGO: 'NADIR_LOGO',
  PROMOTION: 'PROMOTION',
  NAVIGATION: 'NAVIGATION',
  GALLERY: 'GALLERY',
  TEXTURE: 'TEXTURE',
  MARKER_AIM: 'MARKER_AIM',
  LIST_MOVING: 'LIST_MOVING',
};

export const DASHBOARD_BG = `${S3_DOMAIN}/common/media/background_dashboard.png`;

export const CONFIGS = {
  FLARE: `${S3_DOMAIN}/common/configs/flare-config.json`,
};

export const DEFAULT_ICON_HOTSPOT = {
  MOVING: `${S3_DOMAIN}/common/media/vtourskin.png`,
  SOUND: `${S3_DOMAIN}/common/media/hotspot_sound_icon.png`,
  INFO: `${S3_DOMAIN}/common/media/tag.png`,
  ITEM_INFO: `${S3_DOMAIN}/common/media/vtourskin.png`,
  POPUP: `${S3_DOMAIN}/common/media/vtourskin.png`,
  PHOTO: `${S3_DOMAIN}/common/media/gallery.png`,
  VIDEO: `${S3_DOMAIN}/common/media/hotspot_video_icon.png`,
  GALLERY: `${S3_DOMAIN}/common/media/gallery.png`,
  PIN: `${S3_DOMAIN}/common/media/vtourskin.png`,
  FLARE: `${S3_DOMAIN}/common/media/sun.png`,
  SOUND_PLAY: `${S3_DOMAIN}/common/media/play-solid.png`,
  SOUND_PAUSE: `${S3_DOMAIN}/common/media/stop-solid.png`,
  BACKGROUND: `${S3_DOMAIN}/common/media/bgshadow.png`,
  VTOURSKIN_HOTSPOT: `${S3_DOMAIN}/common/media/vtourskin_hotspot.png`,
  PROMOTION: `${S3_DOMAIN}/common/media/promotion_lg.png`,
  NORTH_POINT: `${S3_DOMAIN}/common/media/compass_32x32.svg`,
  TEXTURE: `${S3_DOMAIN}/common/media/vtourskin.png`,
  FOCUSING_IMAGE_STRIP: `${S3_DOMAIN}/common/media/audio_shake.png`,
  AIM: `${S3_DOMAIN}/common/media/aim.svg`,
  AIM_SELECTED: `${S3_DOMAIN}/common/media/aim--selected.svg`,
};

export const POPUP_TYPE = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
  IFRAME: 'IFRAME',
  WEB_ROTATE: 'WEB_ROTATE',
};

export const MEDIA_TYPE = {
  ICON: 'ICON',
  IMAGE: 'IMAGE',
  IMAGE_STATIC: 'IMAGE_STATIC',
  AUDIO: 'AUDIO',
  VIDEO: 'VIDEO',
  TEXTURE: 'TEXTURE',
  TEXTURE_AVATAR: 'TEXTURE_AVATAR',
  SUBTITLE: 'SUBTITLE',
};

export const MEDIA_ACCEPTS_ARRAY = {
  ICON: ['.ico', '.svg', '.png', '.jpg', '.jpeg', '.gif'],
  IMAGE: ['.png', '.jpg', '.jpeg', '.gif'],
  IMAGE_STATIC: ['.png', '.jpg', '.jpeg'],
  AUDIO: ['.mp3', '.ogg'],
  VIDEO: ['.mp4', '.ogg', '.webm'],
  TEXTURE: ['.png', '.jpg', '.jpeg'],
  TEXTURE_AVATAR: ['.png', '.jpg', '.jpeg'],
  SUBTITLE: ['.vtt'],
};

export const MEDIA_ACCEPTS = {
  ICON: MEDIA_ACCEPTS_ARRAY.ICON.join(','),
  IMAGE: MEDIA_ACCEPTS_ARRAY.IMAGE.join(','),
  IMAGE_STATIC: MEDIA_ACCEPTS_ARRAY.IMAGE_STATIC.join(','),
  AUDIO: MEDIA_ACCEPTS_ARRAY.AUDIO.join(','),
  VIDEO: MEDIA_ACCEPTS_ARRAY.VIDEO.join(','),
  TEXTURE_AVATAR: MEDIA_ACCEPTS_ARRAY.TEXTURE_AVATAR.join(','),
  SUBTITLE: MEDIA_ACCEPTS_ARRAY.SUBTITLE.join(','),
};

export const VOICES = {
  VI_VN: {
    code: 'vi-VN',
    nation: 'VI',
    name: 'Vietnamese (vi-VN)',
    flagUrl: '/images/flags/lang-vn.png',
  },
  EN_US: {
    code: 'en-US',
    nation: 'EN',
    name: 'English (en-US)',
    flagUrl: '/images/flags/lang-en-uk.png',
  },
  JA_JP: {
    code: 'ja-JP',
    nation: 'JA',
    name: 'Japanese (ja-JP)',
    flagUrl: '/images/flags/lang-jp.png',
  },
  KO_KR: {
    code: 'ko-KR',
    nation: 'KR',
    name: 'Korean (ko-KR)',
    flagUrl: '/images/flags/lang-kr.png',
  },
  ZH_CN: {
    code: 'zh-CN',
    nation: 'CN',
    name: 'Chinese (zh-CN)',
    flagUrl: '/images/flags/lang-cn.png',
  },
};

export const POI_ACTIONS = [
  {
    type: POI_TYPE.MOVING,
    icon: 'fa-arrow-up',
    position: 'bottom',
  },
  {
    type: POI_TYPE.INFO,
    icon: 'fa-comment-dots',
    position: 'left',
  },
  {
    type: POI_TYPE.SOUND,
    icon: 'fa-headphones',
    position: 'left',
  },
  {
    type: POI_TYPE.POPUP,
    icon: 'fa-external-link-square-alt',
    position: 'left',
  },
  {
    type: POI_TYPE.PHOTO,
    icon: 'fa-image',
    position: 'top',
  },
  {
    type: POI_TYPE.VIDEO,
    icon: 'fa-play-circle',
    position: 'top',
  },
  {
    type: POI_TYPE.GALLERY,
    icon: 'fa-photo-video',
    position: 'top',
  },
  {
    type: POI_TYPE.TEXTURE,
    icon: 'fa-images',
    position: 'top',
  },
  {
    type: POI_TYPE.ITEM_INFO,
    icon: 'fa-book',
    position: 'right',
  },
  {
    type: POI_TYPE.POLYGON,
    icon: 'fa-draw-polygon',
    position: 'right',
  },
  {
    type: POI_TYPE.LENSFLARE,
    icon: 'fa-sun',
    position: 'right',
  },
  {
    type: POI_TYPE.PROMOTION,
    icon: 'fa-tag',
    position: 'bottom',
  },
  {
    type: POI_TYPE.LIST_MOVING,
    icon: 'fa-list',
    position: 'bottom',
  }
];

export const INFO_ITEM_TYPE = {
  LOCATION: 'LOCATION',
  BRAND: 'BRAND',
  PRODUCT: 'PRODUCT',
  ECOMMERCE_PRODUCT: 'ECOMMERCE_PRODUCT',
  FACILITY: 'FACILITY',
};

export const NOTIFICATION_TYPE = {
  REFRESH_SCENE: 'REFRESH_SCENE',
  REFRESH_TOURS: 'REFRESH_TOURS',
};

export const DEFAULT_PAGE_SIZE = 20;
export const DEFAULT_PAGE_SIZE_OPTIONS = ['20', '40', '60', '100'];

export const DEFAULT_PAGINATION: PaginationType = {
  pageable: {},
  sort: {},
  totalPages: 0,
  totalElements: 0,
  last: false,
  first: true,
  numberOfElements: 0,
  size: DEFAULT_PAGE_SIZE,
  number: 0,
  empty: null,
};

export const COLOR_VALUE_FORMAT = {
  HEX: 'hex',
  RGB: 'rgb',
  HSL: 'hsl',
};

export const ITEM_INFO_TEMPLATE = {
  NONE: 'NONE',
  PRODUCT: 'PRODUCT',
  BRAND: 'BRAND',
  LOCATION: 'LOCATION',
  FACILITY: 'FACILITY',
};

export const ITEM_INFO_FOCUS = {
  NONE: 'NONE',
  LABEL: 'LABEL',
};

export const ORDER_INDEX_WITHOUT_CATEGORY = 99;

export const THEME_POI_TYPE = {
  MOVING: 'MOVING',
  SOUND: 'SOUND',
  INFO: 'INFO',
  POPUP: 'POPUP',
  PROMOTION: 'PROMOTION',
  ITEM_INFO_BRAND: 'ITEM_INFO_BRAND',
  ITEM_INFO_LOCATION: 'ITEM_INFO_LOCATION',
  ITEM_INFO_PRODUCT: 'ITEM_INFO_PRODUCT',
  ITEM_INFO_FACILITY: 'ITEM_INFO_FACILITY',
  GALLERY: 'GALLERY',
  TEXTURE: 'TEXTURE',
};

export const GALLERY_TAG = {
  ITEM_INFO: 'ITEM_INFO',
  ITEM_INFO_BRAND: 'ITEM_INFO_BRAND',
  ITEM_INFO_LOCATION: 'ITEM_INFO_LOCATION',
  ITEM_INFO_PRODUCT: 'ITEM_INFO_PRODUCT',
  ITEM_INFO_FACILITY: 'ITEM_INFO_FACILITY',
};

export const THEME_POI_LABELS = {
  MOVING: 'Moving',
  SOUND: 'Sound',
  INFO: 'Info',
  POPUP: 'Popup',
  PROMOTION: 'Promotion',
  ITEM_INFO_BRAND: 'Brand',
  ITEM_INFO_LOCATION: 'Location',
  ITEM_INFO_PRODUCT: 'Product',
  ITEM_INFO_FACILITY: 'Facility',
  GALLERY: 'Gallery',
  TEXTURE: 'Texture',
};

export const THEME_TYPE = {
  TOUR: 'TOUR',
  ICON_SET: 'ICON_SET',
};

export const SCENE_STATUS = {
  PROCESSING: 'PROCESSING',
  RETRYING: 'RETRYING',
  DONE: 'DONE',
  FAILED: 'FAILED',
};

export const COVER_MODE = {
  NONE: 'NONE',
  LOCK_VIEW: 'LOCK_VIEW',
  NADIR_LOGO: 'NADIR_LOGO',
};

export const MOVING_PREVIEW_TYPE = {
  SNEAK_PEEK: 'SNEAK_PEEK',
  LABEL: 'LABEL',
  SNEAK_PEEK_AND_LABEL: 'SNEAK_PEEK_AND_LABEL',
};

export const SINGLE_CLICK_TYPE = {
  NONE: 'None',
  MOVE_TO_SCENE: 'Move to closest scene',
};

export const DEFAULT_LANG_CODE = 'VN';
export const IMAGE_UPLOAD_TYPES = '.ico,.svg,.png,.jpg,.jpeg,.gif,.webp';
export const LANGUAGE: { [key: string]: LanguageType } = {
  VN: {
    code: 'VN',
    name: 'VietNam',
    locale: 'vi_VN',
  },
  EN: {
    code: 'EN',
    name: 'English',
    locale: 'en_US',
  },
  JP: {
    code: 'JP',
    name: 'Japanese',
    locale: 'ja_JP',
  },
  KR: {
    code: 'KR',
    name: 'Korean',
    locale: 'ko_KR',
  },
  CN: {
    code: 'CN',
    name: 'Chinese',
    locale: 'zh_CN',
  },
};

export const PROMOTION_URL_OPEN_TYPE = {
  BUILD_IN: {
    label: 'Build-in',
    value: 'BUILD_IN',
  },
  NEW_TAB: {
    label: 'New tab',
    value: 'NEW_TAB',
  },
  IFRAME: {
    label: 'Iframe',
    value: 'IFRAME',
  },
};

export const ECOMMERCE_PRODUCT_OPEN_TYPE = {
  IFRAME: {
    label: 'Iframe',
    value: 'IFRAME',
  },
  MODAL: {
    label: 'Modal',
    value: 'MODAL',
  },
};

export const DRAFT_TOUR_STATE = {
  DESIGN: {
    value: 'DESIGN',
    label: 'Design',
  },
  PRE_SCAN: {
    value: 'PRE_SCAN',
    label: 'Pre-scan',
  },
  SCANNING: {
    value: 'SCANNING',
    label: 'Scanning',
  },
  DONE: {
    value: 'DONE',
    label: 'Done',
  },
};

export const SCENE_MAX_DELETE = 5;
export const MAX_IMAGE_DIMENSION = 65535;
export const MAX_IMAGE_SIZE = 52428800; // 50MB
export const SCENARIO_ACTION_TYPE = {
  MOVE_SCENE: 'MOVE_SCENE',
  LOOK_AT: 'LOOK_AT',
  ROTATE: 'ROTATE',
  PLAY_SOUND: 'PLAY_SOUND',
  SLEEP: 'SLEEP',
  OPEN_FUNCTION_BUTTON: 'OPEN_FUNCTION_BUTTON',
  SWITCH_SCENE: 'SWITCH_SCENE',
  OPEN_MINIMAP: 'OPEN_MINIMAP'
};

export const SCALE_OPTIONS = [0.5, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];

export const SCENARIO_ACTION_TYPE_ICON = {
  [SCENARIO_ACTION_TYPE.LOOK_AT]: {
    icon: 'fas fa-bullseye',
    backgroundColor: '#46be8a',
    tooltipTitle: 'Look at',
  },
  [SCENARIO_ACTION_TYPE.ROTATE]: {
    icon: 'fas fa-sync-alt',
    backgroundColor: '#f2a654',
    tooltipTitle: 'Rotate',
  },
  [SCENARIO_ACTION_TYPE.PLAY_SOUND]: {
    icon: 'far fa-caret-square-right',
    backgroundColor: '#0887c9',
    tooltipTitle: 'Play sound',
  },
  [SCENARIO_ACTION_TYPE.SLEEP]: {
    icon: 'fas fa-stopwatch',
    backgroundColor: '#fb434a',
    tooltipTitle: 'Sleep',
  },
  [SCENARIO_ACTION_TYPE.OPEN_FUNCTION_BUTTON]: {
    icon: 'fas fa-wrench',
    backgroundColor: '#9743fb',
    tooltipTitle: 'Open function button',
  },
  [SCENARIO_ACTION_TYPE.SWITCH_SCENE]: {
    icon: 'fas fa-image',
    backgroundColor: '#fbf243',
    tooltipTitle: 'Switch scene',
  },
  [SCENARIO_ACTION_TYPE.OPEN_MINIMAP]: {
    icon: 'fas fa-map',
    backgroundColor: '#c41d7f',
    tooltipTitle: 'Open minimap',
  },
};

export const SCANNER_IMAGE_NAME_FORMAT = 'YYYYMMDDHHmmss';

export const TOOL_RENAME_LINKS = [
  'https://clikvirtualtour.s3.ap-southeast-1.amazonaws.com/common/tools/ReNamer/den4b.zip',
  'https://clikvirtualtour.s3.ap-southeast-1.amazonaws.com/common/tools/ReNamer/ReNamer.zip',
];

export const DEFAULT_FRAME_WIDTH = 100;
export const DEFAULT_FRAME_HEIGHT = 100;
export const DEFAULT_FRAME_RATE = 24;

export enum BLEND_MODE_STYLE {
  DEFAULT = 'DEFAULT',
  SIMPLE_CROSS_BLENDING = 'SIMPLE_CROSS_BLENDING',
  ZOOM_BLEND = 'ZOOM_BLEND',
  BLACK_OUT = 'BLACK_OUT',
  WHITE_FLASH = 'WHITE_FLASH',
  RIGHT_TO_LEFT = 'RIGHT_TO_LEFT',
  TOP_TO_BOTTOM = 'TOP_TO_BOTTOM',
  DIAGONAL = 'DIAGONAL',
  CIRCLE_OPEN = 'CIRCLE_OPEN',
  HORIZONTAL_OPEN = 'HORIZONTAL_OPEN',
  VERTICAL_OPEN = 'VERTICAL_OPEN',
}

export const BLEND_MODE_STATIC_URL = '/images/blendMode/static/static_blendmode.png';

export const BLEND_MODE = [
  {
    name: 'Default',
    key: BLEND_MODE_STYLE.DEFAULT,
    url: '/images/blendMode/elliptic-zoom.gif',
  },
  {
    name: 'Simple crossblending',
    key: BLEND_MODE_STYLE.SIMPLE_CROSS_BLENDING,
    url: '/images/blendMode/simple-crossblending.gif',
  },
  {
    name: 'Zoom blend',
    key: BLEND_MODE_STYLE.ZOOM_BLEND,
    url: '/images/blendMode/zoom-blend.gif',
  },
  {
    name: 'Black out',
    key: BLEND_MODE_STYLE.BLACK_OUT,
    url: '/images/blendMode/black-out.gif',
  },
  {
    name: 'White flash',
    key: BLEND_MODE_STYLE.WHITE_FLASH,
    url: '/images/blendMode/white-flash.gif',
  },
  {
    name: 'Right to left',
    key: BLEND_MODE_STYLE.RIGHT_TO_LEFT,
    url: '/images/blendMode/right-to-left.gif',
  },
  {
    name: 'Top to bottom',
    key: BLEND_MODE_STYLE.TOP_TO_BOTTOM,
    url: '/images/blendMode/top-to-bottom.gif',
  },
  {
    name: 'Diagonal',
    key: BLEND_MODE_STYLE.DIAGONAL,
    url: '/images/blendMode/diagonal.gif',
  },
  {
    name: 'Circle open',
    key: BLEND_MODE_STYLE.CIRCLE_OPEN,
    url: '/images/blendMode/circle-open.gif',
  },

  {
    name: 'Horizontal open',
    key: BLEND_MODE_STYLE.HORIZONTAL_OPEN,
    url: '/images/blendMode/horizontal-open.gif',
  },

  {
    name: 'Vertical open',
    key: BLEND_MODE_STYLE.VERTICAL_OPEN,
    url: '/images/blendMode/vertical-open.gif',
  },
];

export const BLEND_SPEED = [
  {
    label: 'Fastest - 0.5',
    value: 'FASTEST',
  },
  {
    label: 'Fast - 0.7',
    value: 'FAST',
  },
  {
    label: 'Normal - 1.0',
    value: 'NORMAL',
  },
  {
    label: 'Slow - 1.5',
    value: 'SLOW',
  },
  {
    label: 'Slowest - 2.0',
    value: 'SLOWEST',
  },
];

export const DEFAULT_BLEND_SPEED = 'NORMAL';

export const DEFAULT_LASER_RANGE = 1;

export const PLUGINS = {
  VIDEO_PLAYER: `${S3_DOMAIN}/common/plugins/videoplayer.js`,
};

export const SOCIAL_TYPE = {
  LINKEDIN: {
    key: 'LINKEDIN',
    pattern: /^http(s*):\/\/(www.)*linkedin\.com\/in\/[a-zA-Z0-9-À-ỹ/]+$/i,
  },
  ZALO: {
    key: 'ZALO',
    pattern: /^http(s*):\/\/zalo\.me\/[0-9+-]+$/i,
    patternPhoneNumber: /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/i,
  },
  YOUTUBE: {
    key: 'YOUTUBE',
    pattern: /^http(s*):\/\/(www.)*youtube\.com\/(?:@|(channel\/))[a-zA-Z0-9./]+$/i,
  },
  MESSENGER: {
    key: 'MESSENGER',
    pattern: /^http(s*):\/\/(www.)*messenger\.com\/t\/[a-zA-Z0-9./]+$/i,
  },
  FACEBOOK: {
    key: 'FACEBOOK',
    pattern: /^http(s*):\/\/((?:www|m).)*facebook\.com\/[a-zA-Z0-9./]+$/i,
  },
  INSTAGRAM: {
    key: 'INSTAGRAM',
    pattern: /^http(s*):\/\/((?:www|m).)*instagram\.com\/[a-zA-Z0-9./]+$/i,
  },
  TWITTER: {
    key: 'TWITTER',
    pattern: /^http(s*):\/\/?(mobile.)?twitter\.com\/[a-zA-Z0-9./]+$/i,
  },
  TIKTOK: {
    key: 'TIKTOK',
    pattern: /^http(s*):\/\/(www.)*tiktok\.com\/@[a-zA-Z0-9./]+$/i,
  },
};

export const MAX_DEG = 360;
export const MIN_DEG = -360;

export const DEVICE_VIEWER = {
  mobile: 'mobile',
  desktop: 'desktop',
  tablet: 'tablet',
};

export const DEVICE_VIEWER_ASPECT = {
  mobile: '9:16',
  desktop: '0',
  tablet: '3:4',
};

export const POI_Z_ORDER = {
  base: 0,
  area: 1,
  polygon: 2,
  poi: 3,
  popup: 2,
};

export const LASER_RANGE_OPTIONS = [0, 1, 2, 3];

export const POPUP_IFRAME_SIZE = {
  HALF: {
    value: 'HALF',
    label: '50%',
  },
  FULL: {
    value: 'FULL',
    label: 'FULL',
  },
};

export const OVERVIEW_POSITION_POI = {
  NONE: 'NONE',
  BOTTOM_LEFT_CORNER: 'BOTTOM_LEFT_CORNER',
};

export const OVERVIEW_TYPE = {
  TEXT: 'TEXT',
  IMAGE: 'IMAGE',
};

export const POSITION_POI = {
  NONE: 'NONE',
  RIGHT: 'RIGHT',
  TOP: 'TOP',
  BOTTOM: 'BOTTOM',
  LEFT: 'LEFT',
  NAMEPLATE: 'NAMEPLATE', // for gallery poi
};

export const MOVING_DISPLAY_TYPE = {
  CLASSIC: 'CLASSIC',
  NAMEPLATE: 'NAMEPLATE',
};

export const MOVING_BG_COLOR_DEFAULT = '#333333';
export const MOVING_TEXT_COLOR_DEFAULT = '#ffffff';

export const MOVING_FONT_SIZE = {
  '6pt': '6pt',
  '7pt': '7pt',
  '8pt': '8pt',
  '9pt': '9pt',
  '10pt': '10pt',
  '10.5pt': '10.5pt',
  '11pt': '11pt',
  '12pt': '12pt',
  '13pt': '13pt',
  '14pt': '14pt',
  '15pt': '15pt',
  '16pt': '16pt',
  '18pt': '18pt',
  '20pt': '20pt',
  '21pt': '21pt',
  '22pt': '22pt',
  '24pt': '24pt',
  '26pt': '26pt',
  '28pt': '28pt',
  '32pt': '32pt',
  '36pt': '36pt',
  '40pt': '40pt',
  '42pt': '42pt',
  '44pt': '44pt',
  '48pt': '48pt',
  '54pt': '54pt',
  '60pt': '60pt',
  '66pt': '66pt',
  '72pt': '72pt',
  '80pt': '80pt',
  '88pt': '88pt',
  '96pt': '96pt',
};

export const MOVING_FONT_SIZE_DEFAULT = MOVING_FONT_SIZE['12pt'];

export const POPUP_SIZE = {
  SMALL: {
    value: 'SMALL',
    label: '80px',
  },
  MEDIUM: {
    value: 'MEDIUM',
    label: '160px',
  },
  LARGE: {
    value: 'LARGE',
    label: '240px',
  },
};

export const LASER_TOOLTIP_SLASH_MAX_SIZE = 500;
export const LASER_RANGE_VALUE = [0, 32, 112, 192];

export const ITEM_INFO_TYPES = {
  PRODUCT: 'PRODUCT',
  BRAND: 'BRAND',
  LOCATION: 'LOCATION',
  ECOMMERCE_PRODUCT: 'ECOMMERCE_PRODUCT',
};

export const GALLERY_TYPE = {
  VIDEO: 'VIDEO',
  IMAGE: 'IMAGE',
  ORBIT_REELS: 'ORBIT_REELS',
  WEB_ROTATE: 'WEB_ROTATE',
};

export const POPUP_ELEMENT_SIZE = {
  POI: 32,
  DOT: 8,
};

export const AGT_ROTATION_FIELD_DEFAULT_VALUE = {
  ANGLE: 180,
  SPEED: 30,
};
export const NO_IMAGE =
  'data:image/png;base64,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';

export const AGT_LOOK_AT_TYPE = {
  POSITION: { key: 'POSITION', value: 'Position' },
  HOTSPOT: { key: 'HOTSPOT', value: 'Hotspot' },
};

export const SUPPORTED_OVERVIEW_POI = [
  POI_TYPE.ITEM_INFO,
  POI_TYPE.PROMOTION,
  POI_TYPE.GALLERY,
  POI_TYPE.POLYGON,
];
export const SUPPORTED_OVERVIEW_POI_ITEM_INFO = [
  ITEM_INFO_TEMPLATE.PRODUCT,
  ITEM_INFO_TEMPLATE.BRAND,
  ITEM_INFO_TEMPLATE.LOCATION,
  ITEM_INFO_TEMPLATE.FACILITY,
];
export const TEXTURE_ITEM_SELECTION_SIZE = 56;
export const DELAY_AUTO_SCROLL = 200; // ms
export const MAX_ICON_SIZE = 1048576; // 1MB
export const MAX_FILE_SIZE = 104857600; // 100MB
export const RIGHT_SIDEBAR_WIDTH = 350;
export const DATE_TIME_FORMAT = 'DD-MM-YYYY HH:mm:ss';
export const DATE_TIME_WITHOUT_SEC_FORMAT = 'DD-MM-YYYY HH:mm';
export const TIME_WITHOUT_SEC_FORMAT = 'HH:mm';

// time to notify to use save config tour (second)
export const TIME_NOTIFY_SAVE = 600;
export const NOTIFICATION_LEVEL = 1;
export const MIN_FOV = 6.5;
export const MAX_FOV = 130;
export const DEFAULT_FOV = 65;

export const LIMIT_VIEW_HORIZONTAL = 360;

export const POI_TEMPLATE_TYPE = {
  MOVING: 'MOVING',
  SOUND: 'SOUND',
  INFO: 'INFO',
  POPUP: 'POPUP',
  PHOTO: 'PHOTO',
  VIDEO: 'VIDEO',
  ITEM_INFO: 'ITEM_INFO',
  POLYGON: 'POLYGON',
  LENSFLARE: 'LENSFLARE',
  PROMOTION: 'PROMOTION',
  GALLERY: 'GALLERY',
  TEXTURE: 'TEXTURE',
};

export const MODEL_3D_ANDROID_UPLOAD_TYPES = '.glb';
export const MODEL_3D_IOS_UPLOAD_TYPES = '.usdz';
